import { FileType } from './Files';

export enum DocumentCategory {
    TAX_DOCUMENT = 'tax_document',
    HISTORICAL_FINANCIAL = 'historical_financial',
    PROPERTY_INFORMATION = 'property_information',
    PERMIT = 'permit',
    OTHER = 'other',
}

export enum DocumentSubCategory {
    W9 = 'w9',
    MONTHLY_RENT_ROLL = 'monthly_rent_roll',
    REVENUE_REPORT = 'revenue_report',
    PROPERTY_MAP = 'property_map',
    PHOTO = 'photo',
}

export const CATEGORY_LABELS: Record<DocumentCategory, string> = {
    [DocumentCategory.TAX_DOCUMENT]: 'Tax Documents',
    [DocumentCategory.HISTORICAL_FINANCIAL]: 'Historical Financials',
    [DocumentCategory.PROPERTY_INFORMATION]: 'Property Information',
    [DocumentCategory.PERMIT]: 'Permits',
    [DocumentCategory.OTHER]: 'Other',
};

export const SUBCATEGORY_LABELS: Record<DocumentSubCategory, string> = {
    [DocumentSubCategory.W9]: 'W9',
    [DocumentSubCategory.REVENUE_REPORT]: 'Historical Financials',
    [DocumentSubCategory.MONTHLY_RENT_ROLL]: 'Monthly Rent Roll',
    [DocumentSubCategory.PROPERTY_MAP]: 'Property Maps & Blueprints',
    [DocumentSubCategory.PHOTO]: 'Entry & Exit Photos',
};

export type DocumentUploadCategory = {
    category: DocumentCategory;
    sub_category: DocumentSubCategory | null;
    is_required: boolean;
    id: number;
};

export type PropertyDocument = {
    category: DocumentUploadCategory | null;
    created_at: string;
    display_name: string;
    file_type: FileType;
    id: string;
    signed_url: string;
    uploaded_by: number;
};
